/**
 * The concept's header actions: 8px radius, 10/14 padding, 12px label.
 *
 * Separate from design-system/primitives/button.tsx deliberately — that one is
 * the shadcn button with its own radius scale and `h-10` sizing, and matching
 * the concept through its variant API meant overriding most of what it sets.
 */
export const ActionButton: React.FC<{
  children: React.ReactNode;
  onClick?: () => void;
  /** 'submit' so a form can be sent with Enter, not just a click handler. */
  type?: 'button' | 'submit';
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  testId?: string;
  /** Names the button when its text alone is ambiguous, as in a list of rows. */
  ariaLabel?: string;
  className?: string;
}> = ({
  children,
  onClick,
  type = 'button',
  variant = 'secondary',
  disabled,
  testId,
  ariaLabel,
  className = '',
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    aria-label={ariaLabel}
    className={`rounded-lg px-3.5 py-2.5 text-xs leading-none transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
      variant === 'primary'
        ? 'bg-primary font-semibold text-primary-foreground hover:bg-[hsl(var(--primary-hover))]'
        : 'border border-border bg-card font-medium text-foreground hover:bg-shell'
    } ${className}`}
  >
    {children}
  </button>
);
